import React, { FC } from 'react'
import { SubmitFeedback } from '../SubmitFeedback'

interface Props {
  isSubmitting: boolean
  submitted: boolean
  comment: string
  onCommentUpdate: (comment: string) => void
  onSubmit: () => void
}

export const PositiveFlow: FC<Props> = (props) => {
  const { isSubmitting, onCommentUpdate, submitted, comment, onSubmit } = props

  return (
    <SubmitFeedback
      onSubmit={onSubmit}
      title="What would bump it up to 5 stars?"
      placeholder="E.g. a bit more sauce"
      submitting={isSubmitting}
      submitted={submitted}
      comment={comment}
      setComment={onCommentUpdate}
    />
  )
}
